module.exports = __webpack_public_path__ + "img/spinneys-original-1920.36d6ff16.png";